import { render } from "./SectionBlog.vue?vue&type=template&id=7c698c1c&scoped=true"
import script from "./SectionBlog.vue?vue&type=script&lang=js"
export * from "./SectionBlog.vue?vue&type=script&lang=js"

import "./SectionBlog.vue?vue&type=style&index=0&id=7c698c1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c698c1c"]])

export default __exports__